import React, { memo } from "react";
import { StyleSheet, View, TouchableOpacity } from "react-native";
import { DrawerActions, useNavigation } from "@react-navigation/native";
import colors from "@constants/color";
import Hamburger from "@assets/svg/Hamburger";
import BackArrow from "@assets/svg/BackArrow";
import Text from "@components/AppText";

const DrawerHeader = memo(({ headerName }) => {
  const navigation = useNavigation();
  const openDrawer = () => {
    navigation.dispatch(DrawerActions.toggleDrawer());
  };

  const navigateToProfile = () => {
    if (navigation && typeof navigation.navigate === "function") {
      navigation.goBack();
    }
  };

  return (
    <View
      style={[
        styles.beLikeRow,
        {
          paddingVertical: 20,
          paddingHorizontal: 10,
          backgroundColor: "#F6F7F9",
        },
      ]}
    >
      <TouchableOpacity
        style={{ paddingRight: 15, paddingVertical: 10, marginLeft: 10 }}
        onPress={navigateToProfile}
      >
        <BackArrow />
      </TouchableOpacity>
      <Text
        fontType="head2"
        style={{
          color: colors.mediumBlack,
        }}
        bold
      >
        {headerName}
      </Text>
    </View>
  );
});

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
    display: "flex",
  },
});

export default DrawerHeader;
